/**
 * 抢头条
 * @author lianghua.fu
 * @date 2022-02-25 09:17:51
 */
import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  getParent,
  getRoot,
  flow,
  types,
} from 'mobx-state-tree';
import { debug, request } from 'lib';
import pickBy from 'lodash/pickBy';
import omitBy from 'lodash/omitBy';
import isNull from 'lodash/isNull';
import FinanceModel from 'models/finance-model';

import { globalStore } from 'stores';
import UserModel from 'models/user-model';

const initState = {
  lastUser: {},
  list: [],
  my: {},
};

const TopUserModel = types.model('TopUserModel', {
  id: 0,
  nickname: '虚位以待',
  rank: 0,
  bean_count_total: 0,
  qty: 0,
  avatar: '',
});

const MyModel = types
  .model('MyModel', {
    qty: 0,
    ranking: 0,
  })
  .views((self) => {
    return {
      get rankingText() {
        if (self.ranking > 5 || !self.ranking) {
          return '未上榜';
        }
        return self.ranking;
      },
    };
  });

const Model = types
  .model('RecommendModel', {
    lastUser: TopUserModel,
    list: types.array(TopUserModel),
    duration: 0,
    my: MyModel,
  })
  .views((self) => {
    return {};
  })
  .actions((self) => {
    const init = flow(function* () {
      let {
        room: { roomId },
      } = getRoot(self);
      let res;
      // try {
      res = yield request.cryolite.get(`api/v2/rankings/top-stars`, {
        uid: roomId,
      });
      //{
      // "last": {
      // "id": 1204541,
      // "nickname": "【Kelly】清儿",
      // "bean_count_total": 1191323252,
      // "qty": 200
      // },
      // "duration": 700,
      // "items": [
      // {
      // "id": 1204541,
      // "nickname": "【Kelly】清儿",
      // "avatar": "https://test-img.sumeme.com/37/5/1571214446757.png",
      // "bean_count_total": 1191323252,
      // "qty": 200
      // }
      // ]
      // }

      self.lastUser =
        _.pickBy(res.data.last, (a) => {
          return a !== null;
        }) || {};
      self.duration = res.data.duration;
      self.list = (res.data.items || [])
        .concat([{}, {}, {}, {}, {}, {}])
        .slice(0, 5)
        .map((item, index) => {
          item.rank = index + 1;
          return item;
        });

      if (res.data.my.qty === null) {
        res.data.my.qty = 0;
      }
      if (res.data.my.ranking === null) {
        res.data.my.ranking = 0;
      }

      self.my = Object.assign(
        {
          qty: 0,
          ranking: 0,
        },
        omitBy(res.data.my, isNull),
      );

      // } catch (e) {
      // }
    });

    const updateDuration = () => {
      self.duration++;
      if (self.duration >= 15 * 60 || self.duration % 15 === 0) {
        init();
      }
    };

    const increaseMyQty = (count) => {
      self.my.qty = self.my.qty + count;
    };

    return {
      init,
      updateDuration,
      increaseMyQty,
    };
  });

export default {
  initState,
  Model,
};
